export default __webpack_public_path__ + "media/src/assets/images/IconClose-d9eb2d5b392a6904ddfb39cd6257881a.svg";